<template>
  <div>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="26vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">کاربران گروه کاربری</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n13 mt-2">
              <v-btn class="mx-2 mr-n16" fab dark small @click="backToUserGroupPage()" color="darkColor" elevation="0">
                <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters class="background-main mx-2 mt-4">
            <v-col cols="12">
              <v-card height="68vh" elevation="0" class="body-card card-width">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" class="">
                      <v-row>
                        <v-col cols="6">
                          <v-row>
                            <span class="page-title">لیست کاربران</span>
                            <v-divider class="mt-3 mr-3 ml-4"></v-divider>
                          </v-row>
                          <v-row>
                            <v-col cols="8">
                              <v-text-field rounded outlined placeholder="جستجو..." append-icon="mdi-magnify" dense
                                v-model="searchTitleNotInGroup"></v-text-field>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="3">
                              <v-btn elevation="0" block rounded class="normal-letter-spacing" color="darkColor" dark
                                @click="addAllList()">
                                افزودن همه لیست
                              </v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                          </v-row>
                          <v-row class="mt-n7">
                            <v-col cols="12">
                              <v-card height="55vh" class="user-card" elevation="0">
                                <v-card-text class="body-over">
                                  <v-row class="mx-3">
                                    <v-col cols="4" class="text-center">
                                      <span class="items-title">نام و نام خانوادگی</span>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                      <span class="items-title">کد ملی</span>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                      <span class="items-title">افزودن به لیست</span>
                                    </v-col>
                                  </v-row>
                                  <v-row class="all-users-items mx-3"
                                    v-for="item in userGroupUsersNotInGroupFilteredList" :key="item.id">
                                    <v-col cols="4" class="text-center">
                                      <h5 class="item-not-in-group-text">
                                        {{ item.firstName }} {{ item.lastName }}
                                      </h5>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                      <h5 class="item-not-in-group-text">
                                        {{ item.nationalCode }}
                                      </h5>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                      <v-icon color="darkColor" @click="addToGroup(item)">
                                        mdi-plus
                                      </v-icon>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="6">
                          <v-row>
                            <span class="page-title">کاربران گروه</span>
                            <v-divider class="mt-3 mr-3"></v-divider>
                          </v-row>
                          <v-row>
                            <v-col cols="8">
                              <v-text-field rounded outlined placeholder="جستجو..." append-icon="mdi-magnify" dense
                                v-model="searchTitleInGroup"></v-text-field>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="3">
                              <v-btn elevation="0" block rounded class="normal-letter-spacing" color="darkColor"
                                @click="removeAllList()" dark>
                                حذف همه لیست
                              </v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                          </v-row>
                          <v-row class="mt-n7">
                            <v-col cols="12">
                              <v-card height="55vh" class="user-card" elevation="0">
                                <v-card-text class="body-over">
                                  <v-row class="mx-3">
                                    <v-col cols="4" class="text-center">
                                      <span class="items-title">نام و نام خانوادگی</span>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                      <span class="items-title">کد ملی</span>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                      <span class="items-title">حذف از لیست</span>
                                    </v-col>
                                  </v-row>
                                  <v-row v-for="item in userGroupUsersInGroupFilteredList" :key="item.id"
                                    class="users-in-group mx-3">
                                    <v-col cols="4" class="text-center">
                                      <h5 class="users-in-group-text">
                                        {{ item.firstName }} {{ item.lastName }}
                                      </h5>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                      <h5 class="users-in-group-text">
                                        {{ item.nationalCode }}
                                      </h5>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                      <v-icon color="#ffffff" @click="removeFromGroup(item)">
                                        mdi-close
                                      </v-icon>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="6">
                          <v-row>
                            <v-spacer></v-spacer>
                            <v-pagination circle v-model="page" :length="totalPages" :total-visible="8"
                              color="lightColor" :value="totalPages" prev-icon="mdi-chevron-left"
                              next-icon="mdi-chevron-right" @next="next()" @previous="previous()"
                              @input="input()"></v-pagination>
                            <v-spacer></v-spacer>
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                          <v-btn rounded color="darkColor" block dark @click="setUsersOfGroupFunction()"
                            class="normal-letter-spacing">
                            ثبت
                          </v-btn>
                        </v-col>
                        <v-col cols="2" class="ml-1">
                          <v-btn outlined rounded block color="darkColor" class="normal-letter-spacing"
                            @click="backToUserGroupPage()">
                            انصراف
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import AlertComponent from '../../../components/AlertComponent.vue';

import snackBar from '@/Mixins/snackBar.js';
import sharedHelper from '@/Helpers/Shared';
import ShearedMixin from '@/Mixins/Shared.js';
import pagination from '@/Mixins/Pagination';
import UserGroupMixin from '@/Mixins/BaseInformation/UserGroupMixin.js';
import UserGroupUsersHelper from '@/Helpers/BaseInformation/UserGroup/UserGroupUsersHelper.js';
export default {
  inject: ['tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
  },
  mixins: [
    ShearedMixin,
    sharedHelper,
    snackBar,
    pagination,
    UserGroupMixin,
    UserGroupUsersHelper,
  ],
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      let route = this.$route.params.id;
      this.userGroupId = route;
      this.newPageSize = 30;
      this.pageSize = 30;
      this.getUserGroupUsersNotInGroupFunction();
      this.getUserGroupUsersInGroupFunction();
    },
    previous: function () {
      this.getUserGroupUsersNotInGroupFunction();
    },
    next: function () {
      this.getUserGroupUsersNotInGroupFunction();
    },
    input: function () {
      this.getUserGroupUsersNotInGroupFunction();
    },
  },
  computed: {
    userGroupUsersNotInGroupFilteredList() {
      return this.allUsersNotInGroup.filter(({ nationalCode, firstName, lastName }) => {
        return (
          nationalCode?.includes(this.searchTitleNotInGroup) ||
          firstName?.includes(this.searchTitleNotInGroup) ||
          lastName?.includes(this.searchTitleNotInGroup)
        );
      });
    },
    userGroupUsersInGroupFilteredList() {
      return this.allUsersInGroup.filter(({ nationalCode, firstName, lastName }) => {
        return (
          nationalCode?.includes(this.searchTitleInGroup) ||
          firstName?.includes(this.searchTitleInGroup) ||
          lastName?.includes(this.searchTitleInGroup)
        );
      });
    },
  },
};
</script>
<style scoped>
.body-card {
  overflow-y: auto !important;
}

.user-card {
  border: 1px solid var(--dark-color) !important;
  border-radius: 15px !important;
}

.items-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c2c2c;
}

.all-users-items {
  background: #d0e6ff !important;
  border-radius: 15px !important;
  margin-bottom: 5px !important;
}

.body-over {
  overflow-y: auto;
  height: 54vh;
}

.users-in-group {
  background: var(--dark-color) !important;
  border-radius: 15px !important;
  margin-bottom: 5px !important;
}

.users-in-group-text {
  color: #ffffff !important;
  margin-top: 3px !important;
  font-weight: normal;
}

.page-title {
  color: var(--dark-color) !important;
}

.item-not-in-group-text {
  color: #333333;
  margin-top: 3px !important;
  font-weight: normal;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
